import React, { createContext, useContext } from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import {IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext} from "../../Context/ZooPassAnswersContext";
import {StepTitleContent} from "../PanelContents/StepTitleContent";
import {ImageAnswerComponent} from "../PanelContents/ImageAnswer";
import ZooPassLocalStateUtility from "../../Utilities/ZooPassLocalStateUtility";

export const Step1SidebarValue : React.FC = () => {

    let {
        dictionary,
        loading
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading
    } = useZooPassAppAnswersContext();
    
    if(!answersLoading && !loading && dictionary !== null && answersData !== null)
    {
        if(answersData.step1Value === 0){
            return (<span>{dictionary.get("ZooPass:ProgressValue:01:false")}</span>)
        }
        if(answersData.step1Value === 1){
            return (<span>{dictionary.get("ZooPass:ProgressValue:01:true")}</span>)
        }
    }
    
    return(<><span>&nbsp;</span></>);
};

